import { createRoot } from 'react-dom/client'
import './style.css'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { useControls } from 'leva'
import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'

const root = createRoot(document.querySelector('#root'))

// function CameraController() {
//   const camera = useThree((state) => state.camera)

//   const { x, y, z, fov } = useControls('Camera', {
//     x: { value: 6, min: -20, max: 20, step: 0.1 },
//     y: { value: 5, min: -20, max: 20, step: 0.1 },
//     z: { value: 6, min: -50, max: 50, step: 0.1 },
//     fov: { value: 25, min: 5, max: 100 },
//   })

//   useEffect(() => {
//     camera.position.set(x, y, z)
//     camera.fov = fov
//     camera.updateProjectionMatrix()
//   }, [x, y, z, fov, camera])

//   return null
// }


root.render(
    <Canvas
        className="r3f"
        flat
        camera={ {
            fov: 25,
            near: 0.1,
            far: 200,
            position: [ 6, 4, 6 ]
        } }
    >
        {/* <CameraController /> */}
        <Experience />
    </Canvas>
)